import React from "react";
import { PanelContainer } from "./PanelContainer";
import { BookOpenCheck } from "lucide-react";
import { QuizIntroScreen } from "@/components/quizzes/QuizIntroScreen";
import { useAuth } from "@/hooks/useAuth";
import type { QuizHelperRequest } from "@/types/quizHelpers";

interface PanelProps {
  isMobile?: boolean;
  contentId?: string | null;
  onHelperRequest?: (req: QuizHelperRequest) => void;
}

export const QuizzesPanel: React.FC<PanelProps> = (props) => {
  const { user } = useAuth();

  if (!user) {
    return (
      <PanelContainer
        {...props}
        title="Quizzes"
        description={
          <>
            Sign in to create and take quizzes. Ask Shattara AI:{" "}
            <span className="font-bold">"Quiz me on Newton's laws with 5 questions."</span>
          </>
        }
        icon={<BookOpenCheck className="h-4 w-4 text-primary" />}
      >
        <div className="p-3 text-xs text-muted-foreground">
          Please log in to use quizzes.
        </div>
      </PanelContainer>
    );
  }

  return (
    <PanelContainer
      {...props}
      title="Quizzes"
      description={
        <>
          Try asking Shattara AI:{" "}
          <span className="font-bold">"Quiz me on Newton's laws with 5 questions."</span>
        </>
      }
      icon={<BookOpenCheck className="h-4 w-4 text-primary" />}
    >
      <QuizIntroScreen 
        userId={user.id} 
        contentId={props.contentId ?? null} 
        onHelperRequest={props.onHelperRequest}
      />
    </PanelContainer>
  );
};
